const data = {
  collect: {
    title: `Collect`,
    levels: [
      {
        title: `Getting Started`,
        summary: `Your data collection is fragmented and inconsistent.`,
        recommendations: [
          `Set a strategy that aligns data collection across sources`,
          `Use a CDP to enforce, validate, and expand your strategy`,
        ],
      },
      {
        title: `Developing`,
        summary: `Your data collection is fragmented and lacks consistency across channels.`,
        recommendations: [`Reconcile your data sources`, `Use a CDP to enforce, validate, and expand your strategy`],
      },
      {
        title: `Leading`,
        summary: `Your data collection is nearly complete, and you have implemented some safeguards to protect data quality.`,
        recommendations: [
          `Validate the scalability of standardized data collection across new teams, apps, and sources`,
          `Use a CDP to enforce, validate, and expand your strategy`,
        ],
      },
      {
        title: `Visionary`,
        summary: `Your data collection is complete and consistent. You collect data from all key channels, and you have implemented safeguards to ensure consistent and accurate collection.`,
        recommendations: [
          `Improve data literacy across the org by making data universally available and understandable`,
          `Build a data council to generate more data champions`,
        ],
      },
    ],
  },
  synthesize: {
    title: `Synthesize`,
    levels: [
      {
        title: `Getting Started`,
        summary: `You are unable to synthesize your data into customer profiles or meaningful insights for your business.`,
        recommendations: [
          `Develop a strategy to establish unique customer identifiers`,
          `Begin resolving those identifiers across channels`,
          `Leverage a tool to build unified customer profiles`,
        ],
      },
      {
        title: `Developing`,
        summary: `You have been able to unify some customer data into profiles and are generating sporadic insights to drive your business forward.`,
        recommendations: [
          `Build holistic, unified customer profiles`,
          `Leverage a tool to help you complete your customer profiles`,
        ],
      },
      {
        title: `Leading`,
        summary: `You have most of your data unified into customer profiles and you’re able to use those profiles to drive business insights.`,
        recommendations: [
          `Perform a gap analysis on customer profiles`,
          `Merge customer profiles with other databases you own`,
        ],
      },
      {
        title: `Visionary`,
        summary: `You are able to harness all customer data, unify it into customer profiles, and use those profiles to power actionable insights for your business.`,
        recommendations: [
          `Educate your organization on the benefits of comprehensive customer profiles`,
          `Explore how to maximize usage of predictive analytics`,
        ],
      },
    ],
  },
  act: {
    title: `Act`,
    levels: [
      {
        title: `Getting Started`,
        summary: `You are unable to take action on your customer data.`,
        recommendations: [`Leverage a CDP capable of generating and updating real-time audiences in your tools`],
      },
      {
        title: `Developing`,
        summary: `You can only take action on a sub-set of your customer data and personalization is inconsistent.`,
        recommendations: [`Strategize and activate use cases for making the most of your CDP`],
      },
      {
        title: `Leading`,
        summary: `You are able to take advanced actions on your customer data and are typically able to deliver personalized experiences.
        `,
        recommendations: [
          `Measure and optimize your ROI and ROAS through attribution tools`,
          `Implement real-time suppression and inclusion audiences to improve advertising efficiency`,
        ],
      },
      {
        title: `Visionary`,
        summary: `You’ve harnessed your data in a way that allows you to take very sophisticated action on your customer data and deliver extremely personalized experiences.`,
        recommendations: [
          `Educate both your company and category on best practices for data-driven customer experiences`,
        ],
      },
    ],
  },
  adapt: {
    title: `Adapt`,
    levels: [
      {
        title: `Getting Started`,
        summary: `You are largely unable to adapt to new technology or data needs for your business.`,
        recommendations: [`Leverage a CDP with pre-built tool integrations`],
      },
      {
        title: `Developing`,
        summary: `You are able to adapt to new technology or data needs for your business, but it requiressignificant effort.`,
        recommendations: [
          `Leverage a CDP with pre-built tool integrations`,
          `Audit and update the efficacy of the instrumentation surrounding your CDP`,
        ],
      },
      {
        title: `Leading`,
        summary: `You can easily activate new tools, platforms, and user dimensions/events to your customer data.`,
        recommendations: [`Optimize every team’s usage of your CDP`, `Ensure all use cases are being addressed`],
      },
      {
        title: `Visionary`,
        summary: `You are set up to adapt your business, if needed. You can quickly and easily activate new tools and platforms, and are leading your industry in the usage of those tools.`,
        recommendations: [
          `Educate both your company and category on best practices for data-driven customer experiences`,
        ],
      },
    ],
  },
}

export default data
